// extracted by mini-css-extract-plugin
export default {"wrap":"Sec01_wrap__Gtag4"};